<template>
	<modal-dialog
		:title="newCustomerModal.title"
		:modal-visible="visible"
		confirm-button-text="Save"
		:working="working"
		v-on:closeModal="closeModal"
		v-on:confirm="saveNewContact">

		<field label="Name" col-class="col-md-4" v-model="newCustomerModal.payload.name" ></field>

		<field label="Phone" col-class="col-md-4" v-model="newCustomerModal.payload.phone" ></field>

		<field label="Email" col-class="col-md-4" v-model="newCustomerModal.payload.email" ></field>

		<address-manual-selector 
			:suite="newCustomerModal.payload.suite"
			:address="newCustomerModal.payload.address"
			:city="newCustomerModal.payload.city"
			:province="newCustomerModal.payload.province"
			:country="newCustomerModal.payload.country"
			:postal-code="newCustomerModal.payload.postal_code"
			col-class="col-md-4"
			v-on:input="updateAddress">
		</address-manual-selector>

		<div v-if="newCustomerModal.newCustomer">

			<field label="Company Type" col-class="col-md-4" v-model="newCustomerModal.payload.company_type" :params="{type:'select',options:companyTypeOptions}" ></field>

		</div>
		<div v-else>

			<field label="Position" col-class="col-md-4" v-model="newCustomerModal.payload.position" ></field>

			<field label="Belongs to (company)" col-class="col-md-4" v-model="newCustomerModal.payload.contact_id" :params="{type:'select',options:optionifiedCompanies}"></field>

		</div>

	</modal-dialog>
</template>

<script type="text/javascript">
import ModalDialog from "../ModalDialog"
import Field from "../Field"
import AddressManualSelector from "@/components/AddressManualSelector"

export default {
	name: "NewContactModal",
	components: {
		ModalDialog,
		Field,
		AddressManualSelector
	},
	props: ["visible","isCompany","isCustomer","customerId"],
	data() {
		return {
			newCustomerModal: {
				title: this.isCustomer ? "New Customer" : "New Contact",
				newCustomer: this.isCustomer,
				payload: {}
			},
			companies: [],
			companyTypes: [],
			working: false,
		}
	},
	computed: {
		optionifiedCompanies() {
			return this.optionify(this.companies,"name")
		},
		companyTypeOptions() {
			return this.optionify(this.companyTypes,"type")
		}
	},
	methods: {
		updateAddress(address) {
			let vm = this

			Object.keys(address).forEach((key,index) => {
				vm.$set(vm.newCustomerModal.payload,key,address[key])
			})
		},
		fetchCompanies() {
			let vm = this

			let filters = JSON.stringify([
				["is_company",1]
			])

			this.getJSON("Contact/get?filters="+filters).then(response => {
				vm.companies = response.data
			})
		},
		fetchCompanyTypes() {
			let vm = this

			this.getJSON("BusinessType/get").then(response => {
				if (response.success)
					vm.companyTypes = response.data
			})
		},
		closeModal() {
			this.$emit("closeModal")
		},
		saveNewContact() {
			let vm = this

			this.spinner(true)
			this.working = true

			if (this.newCustomerModal.newCustomer) {
				this.newCustomerModal.payload.is_customer = 1
				this.newCustomerModal.payload.is_company = 1
			}
			else {
				this.newCustomerModal.payload.is_customer = 0
				this.newCustomerModal.payload.is_company = 0
			}

			if (this.isCompany)
				this.newCustomerModal.payload.is_company = 1
			else
				this.newCustomerModal.payload.is_company = 0

			this.postData("Contact/save",this.newCustomerModal.payload,true).then(response => {
				vm.spinner(false)
				vm.working = false

				vm.alertSaved("New Contact Saved!")

				vm.$emit("contactAdded",response)
			})
		}
	},
	created() {
		this.fetchCompanies()
		this.fetchCompanyTypes()
	}
}

</script>